import React, { useState, useEffect } from "react";

import PageLoader from "../Components/PageLoader";
import { fetchExtensionSettings } from "../utils/zoho";

const ZOHO = window.ZOHO;
window.ZOHO_MODAL_HEIGHT = "750px";

export default function Buttons() {
  const [zohoLoaded, setZohoLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dataCenterUrl, setDataCenterUrl] = useState("");
  const [zohoApiKey, setZohoApiKey] = useState();
  const [orgId, setOrgId] = useState();
  const [zapiKey, setZapiKey] = useState();

  useEffect(() => {
    async function initZoho() {
      ZOHO.embeddedApp.on("PageLoad", async function (data) {
        await ZOHO.CRM.UI.Resize({
          height: window.ZOHO_MODAL_HEIGHT,
          width: "1200",
        });

        const settings = await fetchExtensionSettings();
        setDataCenterUrl(settings.dataCenterUrl);
        setZohoApiKey(settings.apiKey);
        setOrgId(settings.orgId);
        setZapiKey(settings.zapiKey);

        /**
         * Add Business Logic
         */

        setZohoLoaded(true);
      });
      ZOHO.embeddedApp.init();
    }
    initZoho();
  }, []);

  useEffect(() => {
    if (zohoLoaded) {
      /**
       * Add Business Logic
       */
    }
    setLoading(false);
  }, [zohoLoaded]);

  if (loading) {
    return <PageLoader fullScreen />;
  }

  return <>Add Business Logic</>;
}
